import DomComponent from '../lib/domComponent';

export default class WidgetBase extends DomComponent {

    constructor(el) {
        super(el);
    }

}